import { render, staticRenderFns } from "./EUDRSettings.vue?vue&type=template&id=58cf8602&scoped=true"
import script from "./EUDRSettings.vue?vue&type=script&lang=js"
export * from "./EUDRSettings.vue?vue&type=script&lang=js"
import style0 from "./EUDRSettings.vue?vue&type=style&index=0&id=58cf8602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cf8602",
  null
  
)

export default component.exports